import {ICoord} from "../../../../models/animations/ICoord";

export function resolveTargetCoords(
    targetData: any,
    coords: any,
    canvas: HTMLCanvasElement,
    rect: DOMRect,
    scaleX: number,
    scaleY: number
): ICoord | null {

    const getElementCenter = (selector: string): ICoord | null => {
        const el = document.querySelector(selector) as HTMLElement | null;

        if (!el) {
            return null;
        }

        const r = el.getBoundingClientRect();

        return {
            x: (r.left + r.width / 2 - rect.left) * scaleX,
            y: (r.top + r.height / 2 - rect.top) * scaleY,
        };
    };

    const specialResolvers: Record<string, () => ICoord | null> = {
        all: () => ({
            x: canvas.width / 2,
            y: canvas.height / 2,
        }),
        mass_cpu: () => getElementCenter(".playerTable"),
        mass_player: () => getElementCenter(".cpuTable"),
    };

    const special = specialResolvers[targetData.side]?.();

    if (special) {
        return special;
    }

    let targetCoords: ICoord | undefined;

    if (targetData.target === "hp") {
        targetCoords = coords[`${targetData.side}_hp`];
    } else {
        targetCoords = coords[`cell_${targetData.side}_${targetData.target}`];
    }

    if (!targetCoords || targetCoords.x == null || targetCoords.y == null) {
        return null;
    }

    return {
        x: (targetCoords.x - rect.left) * scaleX,
        y: (targetCoords.y - rect.top) * scaleY,
    };
}